import { render } from "./GenericList.vue?vue&type=template&id=22fb5440&scoped=true"
import script from "./GenericList.vue?vue&type=script&lang=js"
export * from "./GenericList.vue?vue&type=script&lang=js"

import "./GenericList.vue?vue&type=style&index=0&id=22fb5440&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22fb5440"]])

export default __exports__